import { DataFormProps } from './index';

export function verifyIfFormCanSave(
	dataForm: DataFormProps,
	setCanSaveModuleOnBack: React.Dispatch<React.SetStateAction<boolean>>,
	setMessageErrorForm: React.Dispatch<React.SetStateAction<string>>
) {
	if (dataForm.buttonLabel === '') {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('Preenha o campo "Label do botão"');
		return;
	}

	if (dataForm.redirect.type === '') {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('Preenha o campo "Tipo redirecionamento"');
		return;
	}

	if (dataForm.redirect.value === '') {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('Preenha o campo "Valor de redirecionamento"');
		return;
	}

	setCanSaveModuleOnBack(true);
}
